import { render, staticRenderFns } from "./CompraPacoteFrete.vue?vue&type=template&id=1bd53641"
import script from "./CompraPacoteFrete.vue?vue&type=script&lang=js"
export * from "./CompraPacoteFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports